// MODIFIED: Payroll Reason Code Table - Added new columns
import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';

const PayrollReasonCodeTable = ({ 
    data, 
    onEdit, 
    currentPage,
    setCurrentPage
}) => {
  const headers = [
    "ID", 
    "Description", 
    "Payroll Code",
    "Field Name",
    "Status", 
    "Actions"
  ];

  const accessors = [
    "id", 
    "description", 
    "payrollCode",
    "fieldName",
    "isActive", 
    "actions"
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Payroll Reason Code List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default PayrollReasonCodeTable;